var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-action-sheet',{on:{"close":_vm.cancelAddressSelect},model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}},[_c('van-area',{attrs:{"title":"选择地区","area-list":_vm.areaList},on:{"cancel":_vm.cancelAddressSelect,"confirm":_vm.confirmAddressSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }